import { render, staticRenderFns } from "./ReportUsers.vue?vue&type=template&id=6fa95164&scoped=true&"
import script from "./ReportUsers.vue?vue&type=script&lang=js&"
export * from "./ReportUsers.vue?vue&type=script&lang=js&"
import style0 from "./ReportUsers.vue?vue&type=style&index=0&id=6fa95164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa95164",
  null
  
)

export default component.exports